import { ApplicationError, AttestationData, ForAttestation } from 'core'

import { HTTPClient } from './http_client'

export class AttestationManager implements ForAttestation {
	private readonly _httpClient = new HTTPClient()

	getToken(): Promise<{
		data?: AttestationData
		error?: ApplicationError
	}> {
		return this._httpClient.fetch<AttestationData>('/attestation-token', {})
	}
}

export class AttestationManagerMock implements ForAttestation {
	private readonly _httpClient = new HTTPClient()

	getToken(): Promise<{
		data?: AttestationData
		error?: ApplicationError
	}> {
		return this._httpClient.fetch<AttestationData>('/attestation-token', {
			baseURL: 'https://local.codigohub.dev:3000'
		})
	}
}
